<template>
  <div class="img-404" id="scene">
    <img src="~@/assets/jiker.com-tp.green-logo.png" class="logo" />
    <img
      src="~@/assets/404/feidie.png"
      class="layer feidie"
      data-depth="0.30"
    />
    <img src="~@/assets/404/img-404.png" class="img404" />
    <!-- <router-link :to="{ name: 'Home'}">返回首页</router-link> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
.img-404 {
  height: 504px;
  position: absolute;
  z-index: 100;
  left: 50%;
  top: 50%;
  margin-left: -175px;
  margin-top: -252px;
}

.img-404 a {
  text-decoration: none;
  font-weight: 400;
  color: #666;
  font-size: 14px;
  position: absolute;
  bottom: -20px;
  display: inline-block;
  text-align: center;
  height: 18px;
  line-height: 20px;
  padding-left: 24px;
  left: 50%;
  margin-left: -40px;
}

.logo {
  height: 60px;
  margin: 0 auto;
  display: block;
}

.feidie {
  display: block;
  width: 203px;
  margin: 20px auto;
}

.img404 {
  width: 350px;
}
</style>
